import React, { useEffect, useRef } from "react"

const Finish = ({ resetAppState }) => {
    const container = useRef(null)

    useEffect(() => {
        resetAppState()
    }, [])

    useEffect(() => {
        if (container?.current) {
            container.current.scrollIntoView({ behaviour: "smooth" })
        }
    }, [container])

    return (
        <div ref={container}>
            <p>Heading to checkout...</p>
        </div>
    )
}

export default Finish
